<div id="openhouse-summary-container" class="prospect-grid-container">
  <div>
    <p>{{tourTypeText}} <b>{{tourTypeDateText}}</b></p>
    <br>
    <p>An email was sent to {{tourSummary.ProspectEmail}} containing details of your upcoming appointment.</p>
    <br>
    <div id="openhouse-cal-anchor"></div>
  </div>
  <div class=tour-profile-info-container>
    <form id="profileInfoForm" #profileInfoForm="ngForm">

      <div>
          <button mat-flat-button color="primary" class=" w-full my-4 font-normal text-2xl sm:text-base"  (click)="onSubmit()">Return to Tours</button>
      </div>
    </form>
  </div>
</div>